export const MAX_LENGTH_GSRN_EAN_NUMBER_ES = 19;
export const MAX_LENGTH_GSRN_EAN_NUMBER_ENEDIS = 14;
export const MAX_LENGTH_STREET_NUMBER = 5;
export const MAX_LENGTH_POST_CODE = 5;
